<div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
  <h2>Copy Style Template</h2>
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-icon class="home-icon" [class.link]="mode !== 'home'" (click)="setMode('home')">home</mat-icon>
    <mat-icon class="tag-icon" [class.link]="mode !== 'tag'" (click)="setMode('tag')">label</mat-icon>
    <mat-icon class="global-icon" [class.link]="mode !== 'global'" (click)="setMode('global')">public</mat-icon>
  </div>
  <div fxFlex class="w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center start">
    <form class="w-100"[formGroup]="renameForm" fxLayout="row" fxLayoutAlign="center center" (ngSubmit)="onRename()">
      <mat-form-field style="max-width: 560px;">
        <mat-label>Style template name</mat-label>
        <input matInput formControlName="newName">
        <mat-error *ngIf="renameForm.get('newName')?.hasError('required')">Style template name is required</mat-error>
      </mat-form-field>
  </form>
  <mat-chip-list *ngIf="mode === 'tag'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
    <mat-chip *ngFor="let tag of allBrandTags"
      [class.green-chip]="selectedTag?.name === tag?.name" (click)="selectedTag?.name === tag?.name ? '' : selectedTag = tag">
      <span>{{ tag?.name }}</span>
      <button matChipRemove color="primary" *ngIf="selectedTag?.name === tag?.name" (click)="selectedTag = undefined">
        <mat-icon color="basic">clear</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-list>
  <!-- <div class="m-t-40" fxFlex="100" *ngIf="requestedProductType">
    <div *ngIf="requestedCompany" fxLayout="column" fxLayoutAlign="start center">
      <img *ngIf="requestedCompany?.logoUrl" class="company-logo" [src]="requestedCompany?.logoUrl">
      <div fxLayout="row" fxLayoutAlign="center center">
        <span>{{ requestedCompany?.name }}</span>
        <button style="transform: scale(0.7);" mat-icon-button color="basic" (click)="clearCompany()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="requestedSupplier" fxLayout="row" fxLayoutAlign="center center">
      <span>{{ requestedSupplier }}</span>
      <button style="transform: scale(0.7);" mat-icon-button color="basic" (click)="clearCompany()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <form>
      <div *ngIf="!requestingSupplier && !requestedCompany" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
        <mat-form-field style="max-width: 540px;">
          <input matInput type="text" placeholder="Select Supplier" matInput [formControl]="companyControl" [matAutocomplete]="companyAuto">
          <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="onCompanySelected($event)">
            <mat-option *ngFor="let company of filteredCompanies | async" [value]="company">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="company-logo-dropdown" *ngIf="company?.logoUrl" [src]="company.logoUrl" [matTooltip]="company?.name" />
                    <span [innerHtml]="company.name | encodeHtml | highlight: companyControl.value"></span>
                </div>
            </mat-option>
          </mat-autocomplete>
          <button mat-button *ngIf="!requestedCompany" matSuffix mat-icon-button matTooltip="Request Supplier" (click)="requestingSupplier = true">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div *ngIf="requestingSupplier && !requestedSupplier" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
        <mat-form-field style="max-width: 540px;">
          <input matInput type="text" placeholder="Enter Supplier" matInput [formControl]="supplierControl">
          <button mat-button *ngIf="!requestedCompany" matSuffix mat-icon-button matTooltip="View Suppliers" (click)="requestingSupplier = false">
            <mat-icon>list</mat-icon>
          </button>
        </mat-form-field>
        <button *ngIf="!requestedCompany" mat-button mat-flat-button color="primary" matTooltip="Request Supplier" (click)="requestSupplier()">
          Request Supplier
        </button>
      </div>
    </form>
  </div> -->
  <div>
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="renameForm.invalid" (click)="addTemplate()">Copy</button>
  </div>
  </div>
</div>